import {PaymentStatusType} from "@app/shared/enums/payment-status-type.enum";
import {PaymentTxnType} from "@app/shared/enums/txn-type.enum";
import {PaymentType} from "@app/shared/enums/payment-type.enum";

export class OrgPaymentTransaction {
  id?: number;
  number?: number;

  transactionId: string;
  paymentType: PaymentType;
  paymentStatus: PaymentStatusType;
  txnType: PaymentTxnType;
  txnDescription: string;
  checkOrReferenceNumber: string;
  transactionDate: Date;

  paymentAmount: number;
  txnTotalAmount: number;
  errorMessage: string;

  txnOrgId: number;
  senderId: number;
  receiverId: number;

  senderPaymentId: number;
  receiverPaymentId: number;
  voucherRegisterId: number;
  paymentFileId: number;
  payrollPeriodId: number;
  achIdForCheckPayment: number;
  payrollPayeeDisbursementId: number;

  senderCustomerId: string;
  receiverCustomerId: string;
  senderPaymentMethodId: string;
  receiverPaymentMethodId: string;
  senderBankName: string;
  senderAccountNumber: string;
  senderRoutingNumber: string;
  receiverBankName: string;
  receiverAccountNumber: string;
  receiverRoutingNumber: string;
  vendorName: string;
  invoiceNumber: string;
  canCancelTransaction: boolean;
}
